import { useCallback, useMemo } from 'react';
import { useCartStore } from '../../store/useCartStore';
import { deriveFreeShippingProgress } from '../../utils/cartCalculations';

export function useCartDrawer() {
  const isCartOpen = useCartStore((s) => s.isCartOpen);
  const isLoading = useCartStore((s) => s.isLoading);
  const items = useCartStore((s) => s.items);
  const itemLineRefs = useCartStore((s) => s.itemLineRefs);
  const count = useCartStore((s) => s.count);
  const total_price = useCartStore((s) => s.total_price);
  const original_total_price = useCartStore((s) => s.original_total_price);
  const total_discount = useCartStore((s) => s.total_discount);
  const currency = useCartStore((s) => s.currency);
  const cart_level_discount_applications = useCartStore((s) => s.cart_level_discount_applications);
  const freeShippingThreshold = useCartStore((s) => s.freeShippingThreshold);
  const isDiscountPanelOpen = useCartStore((s) => s.isDiscountPanelOpen);
  const toggleCart = useCartStore((s) => s.toggleCart);
  const toggleDiscountPanel = useCartStore((s) => s.toggleDiscountPanel);

  const freeShipping = useMemo(
    () => deriveFreeShippingProgress(total_price, freeShippingThreshold),
    [total_price, freeShippingThreshold]
  );

  const openCart = useCallback(() => toggleCart(true), [toggleCart]);
  const closeCart = useCallback(() => toggleCart(false), [toggleCart]);

  return {
    isCartOpen,
    isLoading,
    items,
    itemLineRefs,
    count,
    total_price,
    original_total_price,
    total_discount,
    currency,
    cart_level_discount_applications,
    freeShipping,
    isDiscountPanelOpen,
    openCart,
    closeCart,
    toggleCart,
    toggleDiscountPanel
  };
}
